import {updateState, defaultState } from "../gameState"

const resetGameState = () => updateState({
    ...structuredClone(defaultState),
    level: {
        ...structuredClone(defaultState.level),
        chunkIndex: -1,
        speed: 0,
        startedAt: performance.now()
    }
})

export default resetGameState